import { X, AlertTriangle, Info, CheckCircle, XCircle } from 'lucide-react';
import { useEffect, useState } from 'react';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  onClose: () => void;
}

const toastStyles = {
  success: {
    bg: 'bg-green-50 border-green-200',
    text: 'text-green-800',
    icon: CheckCircle,
    iconColor: 'text-green-600',
  },
  error: {
    bg: 'bg-red-50 border-red-200',
    text: 'text-red-800',
    icon: XCircle,
    iconColor: 'text-red-600',
  },
  warning: {
    bg: 'bg-orange-50 border-orange-200',
    text: 'text-orange-800',
    icon: AlertTriangle,
    iconColor: 'text-orange-600',
  },
  info: {
    bg: 'bg-blue-50 border-blue-200',
    text: 'text-blue-800',
    icon: Info,
    iconColor: 'text-blue-600',
  },
};

export function Toast({ message, type = 'info', duration = 5000, onClose }: ToastProps) {
  const [isVisible, setIsVisible] = useState(true);
  const styles = toastStyles[type];
  const Icon = styles.icon;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!isVisible) return null;

  return (
    <div
      className={`animate-slideDown fixed top-20 left-1/2 z-50 -translate-x-1/2 transform ${styles.bg} ${styles.text} max-w-md rounded-lg border p-4 pr-12 shadow-lg`}
    >
      <button
        onClick={() => {
          setIsVisible(false);
          setTimeout(onClose, 300);
        }}
        aria-label="סגור הודעה"
        className="absolute top-3 left-3 text-gray-400 transition-colors before:absolute before:top-1/2 before:left-1/2 before:size-10 before:-translate-x-1/2 before:-translate-y-1/2 before:content-[''] hover:text-gray-600"
      >
        <X size={16} />
      </button>
      <div className="flex items-center gap-3">
        <Icon className={styles.iconColor} size={20} />
        <p className="text-sm font-medium">{message}</p>
      </div>
    </div>
  );
}
